import "core-js/modules/es.array.iterator.js";
import React from 'react';
import clsx from 'clsx';
import { FormSize } from "../../../../view-model";
import { useFormCommonProps } from "../../../context/form-common";
import { nanoid } from 'nanoid';
import "./input-text.style.scss";
export const InputTextOutlined = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    onChange,
    onFocus,
    onBlur,
    value,
    error,
    placeholder,
    maxLength,
    size,
    disabled,
    readOnly
  } = useFormCommonProps(props);
  const [focused, setFocused] = React.useState(false);
  const id = React.useMemo(() => nanoid(), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "input-text-outlined-container"
  }, /*#__PURE__*/React.createElement("label", {
    className: clsx(focused || value ? 'text-outlined-label-top' : ['text-outlined-label', {
      'text-outlined-label-sm': size === FormSize.SM,
      'text-outlined-label-lg': size === FormSize.LG,
      'text-outlined-label-xl': size === FormSize.XL
    }], {
      'text-outlined-focused': focused,
      'text-outlined-error': error
    }),
    htmlFor: id
  }, placeholder), /*#__PURE__*/React.createElement("div", {
    className: clsx('text-outlined-control', {
      'text-outlined-focused': focused,
      'text-outlined-error': error
    })
  }, /*#__PURE__*/React.createElement("input", {
    ref: ref,
    type: "text",
    id: id,
    className: clsx('text-outlined-input', {
      'text-outlined-sm': size === FormSize.SM,
      'text-outlined-lg': size === FormSize.LG,
      'text-outlined-xl': size === FormSize.XL
    }),
    value: value,
    onChange: e => {
      onChange && onChange(e.target.value, e);
    },
    onFocus: () => {
      setFocused(true);
      onFocus && onFocus();
    },
    onBlur: () => {
      setFocused(false);
      onBlur && onBlur();
    },
    readOnly: readOnly,
    disabled: disabled,
    maxLength: maxLength
  }), /*#__PURE__*/React.createElement("fieldset", {
    "aria-hidden": "true",
    className: "text-outlined-fieldset-notched text-outlined-fieldset"
  }, /*#__PURE__*/React.createElement("legend", {
    className: clsx(focused || value ? 'text-outlined-legend-top' : 'text-outlined-legend')
  }, /*#__PURE__*/React.createElement("span", null, placeholder))))));
});